import * as index from './constants/index.js';
import * as index$1 from './utils/index.js';

const SSPModule = {
    Constants: index,
    Utils: index$1
};

export { SSPModule };
//# sourceMappingURL=index.js.map
